export const FEED_SHIFTS = ['A', 'B', 'C', 'D', 'E'];

export const USER_MODAL_TYPES = {
  SWITCH: 'switch',
  ADD: 'add',
  DELETE: 'delete',
};
